(function () {
  'use strict';

  var content = document.querySelector('[data-person-content]');
  var tocList = document.querySelector('[data-person-toc-list]');
  if (!content || !tocList) return;

  var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));
  if (!headings.length) {
    tocList.parentElement.hidden = true;
    return;
  }

  headings.forEach(function (heading, index) {
    var id = heading.id || 'person-section-' + (index + 1);
    heading.id = id;

    var item = document.createElement('li');
    item.className = heading.tagName.toLowerCase() === 'h3' ? 'level-h3' : 'level-h2';
    var link = document.createElement('a');
    link.href = '#' + id;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var top = heading.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, null, '#' + id);
    });
    item.appendChild(link);
    tocList.appendChild(item);
  });

  var links = Array.prototype.slice.call(tocList.querySelectorAll('a'));
  function updateActiveLink() {
    var current = headings[0].id;
    var position = window.pageYOffset + 140;
    headings.forEach(function (heading) {
      if (heading.offsetTop <= position) current = heading.id;
    });
    links.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('href') === '#' + current);
    });
  }

  window.addEventListener('scroll', updateActiveLink, { passive: true });
  updateActiveLink();
})();
